import { type FC, memo } from 'react';
import styles from './swap-header.module.scss';
import { useNavigate } from 'react-router-dom';
import SelectSlippage from '@components/select-slippage';

const SwapHeader: FC = () => {
  const navigator = useNavigate();

  const link = () => {
    navigator('/limit');
  };

  return (
    <div className={styles.header}>
      <div className={styles.tab}>
        <div className={styles.active}>Swap</div>
        <div onClick={link}>Limit</div>
      </div>
      <SelectSlippage />
    </div>
  );
};

export default memo(SwapHeader);
